var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1OldProductReference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 0L12 14.78v29.69L21.62 50l3-2.92L16 42.15v-22l20 11.54v21.86l-7-4.06v4.6L35.65 58 38 59.34l26-14.87V14.78L38 0zm0 4.6l20.89 11.9-7.63 4.41L29.89 9.18 38 4.6zM17.38 16.32l8.15-4.65L47 23.34l-8.71 5-20.91-12.02zM60 42.15l-20 11.4V32l8-4.62v10.25l4-2.5V25.08l8-4.64v21.71zM23.66 63h34v4h-34v9L11.57 65l12.09-11v9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Old_product_reference.25a32839.svg";
export { SvgK1OldProductReference as ReactComponent };